import { Tabs } from 'antd';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Error403Unauthorized } from '@app/components';
import {
  FORBIDDEN_ERROR_MAIN_PART,
  ORGANIZATIONS_PATH,
  PREFIX,
} from '@app/constants';
import { useAccessToOrganizations } from '@app/hooks';

import { ModulesRights } from '@pages/Organizations/OrganizationSettings/components/ModulesRights';
import { OrganizationTariffs } from '@pages/Organizations/OrganizationSettings/components/OrganizationTariffs';

import type { TabsProps } from 'antd';

import '@pages/Organizations/OrganizationSettings/styles/OrganizationSettings.desktop.scss';
import '@pages/Organizations/OrganizationSettings/styles/OrganizationSettings.tablet.scss';

const MODULES_TAB_KEY = 'modules';
const TARIFFS_TAB_KEY = 'tariffs';

export const OrganizationSettings = () => {
  const { areRightsToOrganizationsModule } = useAccessToOrganizations();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const organizationId = Number(searchParams.get('id')) || undefined;

  useEffect(() => {
    if (areRightsToOrganizationsModule && !organizationId) {
      navigate(ORGANIZATIONS_PATH);
    }
  }, [areRightsToOrganizationsModule, organizationId, navigate]);

  const items: TabsProps['items'] = [
    {
      key: MODULES_TAB_KEY,
      label: 'Модули',
      children: <ModulesRights />,
    },
    {
      key: TARIFFS_TAB_KEY,
      label: 'Тарифы',
      children: organizationId ? (
        <OrganizationTariffs organizationId={organizationId} />
      ) : null,
    },
  ];

  if (!areRightsToOrganizationsModule) {
    return <Error403Unauthorized title={`${FORBIDDEN_ERROR_MAIN_PART}.`} />;
  }

  return (
    <div className={`${PREFIX}organization-settings`}>
      <Tabs
        defaultActiveKey={MODULES_TAB_KEY}
        type="card"
        destroyOnHidden
        items={items}
      />
    </div>
  );
};
